import * as carrier from 'src/api/carrier'
import router from 'src/router'
import {
  GET_ALL_CARRIERS,
  GET_CARRIER
} from 'src/store/mutation-types'

const getAllCarriers = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  carrier.getAllCarriers(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS, [])
    }
  })
}

const getCarrier = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  carrier.getCarrier(configs.id, configs.params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_CARRIER, response.data)
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'carrier'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setCarrier = ({commit}, carrier) => {
  commit(GET_CARRIER, carrier)
}

export default{
  getAllCarriers,
  getCarrier,
  setCarrier
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/actions.js